import { Box } from "@mui/material";
import React, { useEffect } from "react";
import VMLogin from "./VMLogin";

function VMMainForm() {
  // const theme = useTheme();
  // const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh", // ✅ FIX (instead of 200vh / 100vh mix)
        backgroundImage: "/static/background.jpg",//`url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        fontFamily: "Lato, sans-serif",
      }}
    >
      <VMLogin />
    </Box>
  );
}

export default VMMainForm;
